import { render } from "./MenuNavigation.vue?vue&type=template&id=39229012&scoped=true"
import script from "./MenuNavigation.vue?vue&type=script&lang=js"
export * from "./MenuNavigation.vue?vue&type=script&lang=js"

import "@/assets/scss/style.basco.scss?vue&type=style&index=0&id=39229012&lang=scss&scoped=true&external"
import "@/assets/scss/responsive.basco.scss?vue&type=style&index=1&id=39229012&lang=scss&scoped=true&external"
import "./MenuNavigation.vue?vue&type=style&index=2&id=39229012&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39229012"]])

export default __exports__